import { FC, useState } from 'react';
import styles from './BillingCalculationSection.module.scss';
import ExpandableSelector from 'components/UI/V3/ExpandableSelector';
import { ExpandableSelectorList, ExpandableSelectorItem } from 'components/UI/V3/ExpandableSelector/List';
import { RadioGroup } from 'components/UI/V3/Forms/RadioGroup/RadioGroup';
import { GracePeriodSection } from '../LatePickup/GracePeriodSection';
import { getBusinessTimeOptions } from 'utils/TimeOptionsUtils';
import { BILLING_CALCULATION, BillingCalculation, BOARDING_DEFAULTS } from 'model/Service';

interface BillingCalculationSectionProps {
    billingCalculation: BillingCalculation;
    onBillingCalculationChange: (value: BillingCalculation) => void;
    checkoutCutoffTime: string;
    onCheckoutCutoffTimeChange: (time: string) => void;
    checkoutGracePeriod: number;
    onCheckoutGracePeriodChange: (value: number) => void;
    className?: string;
}

const billingCalculationOptions = [
    { value: BILLING_CALCULATION.EVERY_24_HOURS, inlineLabel: 'Every 24 Hours' },
    { value: BILLING_CALCULATION.CHECK_IN_CHECK_OUT, inlineLabel: 'Check-In & Check-Out' },
    { value: BILLING_CALCULATION.BY_CALENDAR_DAY, inlineLabel: 'By Calendar Day' }
];

export const BillingCalculationSection: FC<BillingCalculationSectionProps> = ({
    billingCalculation,
    onBillingCalculationChange,
    checkoutCutoffTime,
    onCheckoutCutoffTimeChange,
    checkoutGracePeriod,
    onCheckoutGracePeriodChange,
    className
}) => {
    const [cutoffExpanded, setCutoffExpanded] = useState(false);
    const timeOptions = getBusinessTimeOptions(6, 22, 15, '12h').map(option => option.label);

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <RadioGroup
                label="Billing Calculation"
                value={billingCalculation}
                options={billingCalculationOptions}
                onChange={onBillingCalculationChange}
                className={styles.modeRadio}
            />

            {billingCalculation === BILLING_CALCULATION.BY_CALENDAR_DAY && (
                <div className={styles.calendarDayFields}>
                    <div className={styles.timeSection}>
                        <label className={styles.timeLabel}>
                            Checkout Cutoff Time <span className={styles.required}>*</span>
                        </label>
                        <ExpandableSelector
                            id="billing-checkout-cutoff"
                            label={checkoutCutoffTime || BOARDING_DEFAULTS.CHECKOUT_CUTOFF_TIME_LABEL}
                            expanded={cutoffExpanded}
                            dropdownAlign="right"
                            onExpand={() => setCutoffExpanded(!cutoffExpanded)}
                            onClickAway={() => setCutoffExpanded(false)}
                            className={styles.cutoffSelector}
                        >
                            <ExpandableSelectorList>
                                {timeOptions.map(time => (
                                    <ExpandableSelectorItem
                                        key={time}
                                        onClick={() => {
                                            onCheckoutCutoffTimeChange(time);
                                            setCutoffExpanded(false);
                                        }}
                                        selected={checkoutCutoffTime === time}
                                    >
                                        {time}
                                    </ExpandableSelectorItem>
                                ))}
                            </ExpandableSelectorList>
                        </ExpandableSelector>
                    </div>

                    <GracePeriodSection
                        value={checkoutGracePeriod}
                        onChange={onCheckoutGracePeriodChange}
                    />
                </div>
            )}
        </div>
    );
};
